module.exports = __webpack_public_path__ + "static/media/demo_2.23f2d2ef.mp4";